import request from '@/utils/server'
// 查询菜品列表
export function getEvaluate(query) {
    return request({
      url: '/dish/getEvaluate',
      method: 'get',
      params: query
    })
  }
   //   删除
  export function deleteEvaluate(data) {
    return request({
      url: '/dish/deleteEvaluate',
       method: 'POST',
      data: data
    })
  }
  